import React from "react";
import {
  useOrderStatus,
  useProductOrderStatuses,
} from "../../../../api/order-management/use-order-status";
import { useSetState } from "../../../../utils/hooks";
import { OrderTable } from "../order-table";
import OrderReturnedInfo from "./Section/OrderReturnedInfo";

export const OrderReturned = () => {
  const [filter, dispatchFilter] = useSetState();
  const { isEmpty, getDataTableProps } = useOrderStatus(filter, "RETURNED");
  const { data } = useProductOrderStatuses();
  const returnRefundData = data?.data?.returnRefund;
  return (
    <>
      <OrderReturnedInfo returnRefundData={returnRefundData} />
      <OrderTable isEmpty={isEmpty} getDataTableProps={getDataTableProps} />
    </>
  );
};
